import React from "react";

const Marquee = ({ items = [], duration = 60 }) => {
  const seq = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-warmth/40 py-6 bg-canvas/50 relative">
      <div
        className="marquee-track gap-16"
        style={{ animationDuration: `${duration}s` }}
      >
        {seq.map((x, i) => (
          <span
            key={i}
            className="font-display italic text-depth/80 text-2xl md:text-3xl whitespace-nowrap"
          >
            {x} <span className="text-signal not-italic font-mono text-sm align-middle mx-6">✿</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
